
import {defineComponent} from "vue";
import BannerSlotOverview from "@/components/layouts/banners/BannerSlotOverview.vue";

export default defineComponent({
  name: "CustomerBannerSlotOverview",
  components: {BannerSlotOverview},
})
